import React from "react";
import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { useContentState } from "./useContentState";
import { ContentItems } from "./ContentItems";
import { Region, Group } from "../core/pdf/types";
import { GroupContext } from "./useGroup";
import { ElementTag } from "./ElementTag";
import { toMillimeters } from "../core/pdf/utils";

export function RegionEditor(props: {
	region: Region,
}) {
	const designer = useDesigner();
	const region = props.region;

	const regionState = React.useMemo(() => {
		return {
			item: region, 
		}
	}, [region]);

	const elementContext = useElementContext(region);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const contentStyle = {};

	const style = {
		left: toMillimeters(region.position.x) + "mm",
		top: toMillimeters(region.position.y)  + "mm",
		width: toMillimeters(region.size.w)  + "mm",
		height: toMillimeters(region.size.h)  + "mm",
	};


	return (
		<ElementContext.Provider value={elementContext}>
			<GroupContext.Provider value={regionState}>
				<div
					className={"region content-element flex align-start " + state.classes}
					data-key={region.id}
					id={state.elementID}
					style={style}
				>
					<ElementTag side="left" />

					<div style={contentStyle} className="fill">
						<ContentItems
							content={region.content}
						/>
					</div>
				</div>
			</GroupContext.Provider>
		</ElementContext.Provider>
	)
}